import { Component, OnInit } from '@angular/core';
import { JoiAppData, canGoStraightToApp } from 'globals/store/app.data';
import { ActivatedRoute } from '@angular/router';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { isEmailValid } from 'globals/helpers/helpers';
import { MobileLoginInputComponent } from './mobile-login-input.component';
import { MobileLoginWrapperComponent } from './mobile-login-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'mobile-login-app',
    template: `
<mobile-login-wrapper 
  [disabled]="(appData?.nameAndEmail && (!appData.name || !appData.email)) || (appData?.passwordProtected && !password && !appData.id)" 
  [buttonText]="'login'"
  (onButtonClick)="submit()"
>
  <ng-container *ngIf="!!appData?.nameAndEmail">
    <mobile-login-input [label]="'Name'" [placeholder]="'Please enter your name'" [object]="appData" [prop]="'name'" [error]="nameError"></mobile-login-input>
    <mobile-login-input [label]="'Email'" [placeholder]="'Please enter your email'" [object]="appData" [prop]="'email'" [error]="emailError"></mobile-login-input>
  </ng-container>
  <ng-container *ngIf="!!appData?.passwordProtected">
    <div *ngIf="appData.id" class="entered">Password already entered</div>
    <mobile-login-input *ngIf="!appData.id" [label]="'Password'" [placeholder]="'Please enter the password for the app'" [object]="this" [prop]="'password'" [error]="passwordError"></mobile-login-input>
  </ng-container>
</mobile-login-wrapper>
<div class="bottom-spacer" *ngIf="!!appData?.nameAndEmail || !!appData?.passwordProtected"></div>
`,
    styles: [`
.entered { color: white; margin: 20px auto 0; font-weight: 100; }
mobile-login-input { margin-top: 20px; }
mobile-login-wrapper { min-height: 100vh; }
.bottom-spacer { min-height: 30vh; background: inherit; }
:host { overflow-y: scroll; display: block; height: 100vh; background: #41474f; }

`],
    standalone: true,
    imports: [MobileLoginInputComponent, MobileLoginWrapperComponent, CommonModule]
})
export class MobileLoginAppComponent extends MobileAppWrapper<MobileLoginAppComponent> implements OnInit {
  publishCode: string = ''
  appData: JoiAppData
  nameError = ''
  emailError = ''
  passwordError = ''
  password: string

  constructor(private route: ActivatedRoute) {
    super()
  }

  async submit() {
    this.passwordError = ''
    this.checkAppInfo()
    if (!this.emailError) {
      const returnedAppData = await this.mobileAppService.loadAppData(this.appData.publishCode, this.password)
      this.appData.id = returnedAppData.id || null
      this.appData.nameAndEmail = !!returnedAppData.nameAndEmail
      this.appData.passwordProtected = !!returnedAppData.passwordProtected
      this.mobileAppService.saveAppData(this.appData)

      if (returnedAppData.id) this.router.navigate(['app', returnedAppData.id])
      else this.passwordError = 'invalid password'
    }
    this.checkAppInfo()
  }

  ngOnInit() {
    this.route.paramMap.subscribe(paramMap => {
      this.publishCode = paramMap.get('publishCode')
      console.log({ publishCode: this.publishCode })
      if (this.publishCode) this.loadAppInfo()
    })
  }

  checkAppInfo(showErrors = true) {
    if (!this.appData) {
      this.router.navigate([''])
      return
    }
    else if (canGoStraightToApp(this.appData)) {
      this.mobileAppService.saveAppData(this.appData)
      this.router.navigate(['app', this.appData.id])
    }

    if (showErrors && this.appData.nameAndEmail) {
      this.emailError = isEmailValid(this.appData.email) ? '' : 'Invalid email'
    }
  }

  async loadAppInfo() {
    this.appData = await this.mobileAppService.loadLocalAppDataByPublishCode(this.publishCode)
    if (!this.appData) {
      try {
        this.appData = await this.mobileAppService.loadAppData(this.publishCode)
      } catch (error) {
        console.error(error)
        this.mobileAppService.exitApp()
        return 
      }
    }

    console.log({ appData: this.appData })
    this.checkAppInfo(false)
  }



}

